import {settingsBlockedUsersPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'

type BlockUserPersonallyInput = {
  closeContent: boolean
  contentId: string
  note?: string
  returnTo: string
  userLogin: string
}

export async function blockUserPersonally({
  input: {closeContent, contentId, note, returnTo, userLogin},
  onError,
  onCompleted,
}: {
  input: BlockUserPersonallyInput
  onError?: (error: Error) => void
  onCompleted?: () => void
}) {
  const formData = new FormData()
  formData.append('login', userLogin)
  formData.append('content_id', contentId)
  formData.append('return_to', returnTo)
  if (note) formData.append('note', note)
  if (closeContent) formData.append('close_content', '1')

  try {
    const response = await verifiedFetch(settingsBlockedUsersPath({}), {
      method: 'POST',
      body: formData,
      redirect: 'manual',
    })

    if (!response.ok && response.type !== 'opaqueredirect') {
      throw new Error('Failed to block user')
    }

    onCompleted?.()
  } catch (error) {
    onError?.(error instanceof Error ? error : new Error('Failed to block user'))
  }
}
